import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { adminLogin, formatApiError } from "../../lib/api";
import { Logo } from "../woven/Logo";

export const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await adminLogin(password);
      onLogin(data.token);
    } catch (err) {
      setError(err.response?.status === 401 ? "Access denied. That password isn't right." : formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F2E9] grain flex items-center justify-center px-4">
      <form onSubmit={submit} data-testid="admin-login-form" className="relative w-full max-w-md warm-card p-8 sm:p-10">
        <Logo />
        <h1 className="mt-8 font-serif text-3xl text-[#2C221E]">Waitlist admin</h1>
        <p className="mt-2 text-sm text-[#5C4F4A]">Enter the owner password to view signups.</p>
        <label htmlFor="admin-password" className="mt-8 block text-sm font-medium text-[#2C221E]">Password</label>
        <div className="mt-2 flex items-center gap-3 rounded-2xl border border-[#E6DEC6] bg-[#FDFBF7] px-4 focus-within:border-[#C85A32] transition-colors">
          <Lock className="h-4 w-4 text-[#8A7A72]" />
          <input
            id="admin-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password-input"
            className="w-full bg-transparent py-3.5 text-base outline-none text-[#2C221E]"
          />
        </div>
        {error && <p role="alert" data-testid="admin-login-error" className="mt-3 text-sm font-medium text-[#B24E2A]">{error}</p>}
        <button type="submit" disabled={loading || !password} data-testid="admin-login-button" className="btn-primary mt-8 w-full justify-center">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
};
